import { useParams, useSearchParams } from "react-router-dom";
import { useStationOrders } from "../hooks/useOrders";
import OrderCard from "../components/OrderCard";
import KdsScaleButton from "../components/KdsScaleButton";
import { useKdsScale } from "../hooks/useKdsScale";
import { useTranslation } from "../i18n";

export default function StationView() {
  const { t } = useTranslation();
  const { stationId } = useParams();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId") || localStorage.getItem("kitchen_clientId");

  const { data: orders } = useStationOrders(stationId ?? null, clientId);
  // This screen is its own monitor and keeps its own answer about size.

  // This screen is its own monitor and keeps its own answer about size.
  const { scale: kdsScale, cycle: cycleKdsScale } = useKdsScale();

  return (
    <div className="min-h-screen bg-kds-bg p-4">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-kds-title text-kds-text">{t("kds.station.fallbackName", "Stazione")}</h1>
        <div className="flex items-center gap-4">
          <span className="text-kds-muted text-kds-meta">
            {t("kds.station.ordersCount", "{{count}} ordini", { count: orders?.length ?? 0 })}
          </span>
          <KdsScaleButton scale={kdsScale} onCycle={cycleKdsScale} />
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        {(orders ?? []).map((order: any) => (
          <OrderCard key={order.id} order={order} />
        ))}
      </div>

      {(!orders || orders.length === 0) && (
        <div className="text-center text-kds-muted py-20">
          <p className="text-kds-title">{t("kds.station.noActiveOrders", "Nessun ordine attivo")}</p>
        </div>
      )}
    </div>
  );
}
